import { System } from '../resources/system';

export class DecimalSystemHelper {
    //Utilizar para formatear decimales para cálculos
    public parseAmountByDecimal(system: System, amount: number): number {
        if (isNaN(amount)) {
            return 0;
        }

        if (system.attributes.decimal_places === 0) {
            return Math.floor(amount);
        } else {
            return parseFloat(Number(amount).toFixed(system.attributes.decimal_places));
        }
    }

    //Utilizar para formatear decimales para las vistas
    public formatDecimal(value: number | null | undefined, decimal_places: number): string {
        const numericValue: number = Number(value);
        if (isNaN(numericValue)) {
            return '0.00';
        }

        if (decimal_places === 0) {
            return Math.floor(numericValue).toString();
        }

        if (numericValue.toString().indexOf('.') === -1) {
            return numericValue.toString() + '.00';
        }

        let decimalPlaces: number = decimal_places;

        return this.changePunctuationMark(
            numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: decimalPlaces })
        );
    }

    private changePunctuationMark(refactoredNumber: string): string {
        return refactoredNumber.replace(/,/g, '');
    }
}
